import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer, toast } from 'react-toastify';
import { formatShorthand, formatPhone } from '../../common/utils';
import BorrowerNamesInGrid from '../../containers/Loans/BorrowerNamesInGrid';
import { ActiveLoansModal } from '../../contexts';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import Toolbar from './toolbar';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';
import { Spinner } from 'react-bootstrap';

function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const LoansConstruction = ( { orgId, aid, uid, user, grids, viewing, canExport, stack, loans, contacts, status, setDatagridWidth, setDatagridOrder } ) => {
    const [ trx, setTrx ] = useState( 0 );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ stages, setStages ] = useState( [] );
    const [ actives, setActives ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );

    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    const location = useLocation();

    const query = useQuery();

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'constructionloans';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'constructionloans';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const gridHelpers = {
        valueGetter: {
            borrowers: ( params ) => {
                let v = [];
                if ( params.row.borrowers ) {
                    params.row.borrowers.forEach( b => v.push( b.name ) );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let refId;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c.referredById ) {
                        refId = c.referredById;
                    }
                }
                return refId;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <BorrowerNamesInGrid row={row} />,
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { value } ) => {
                let l;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                let n;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        n = formatName( c.cid );
                    }
                }
                return n;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const gridRef = useGridApiRef();
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const updateKPIs = useCallback( ( model, details ) => {
        const stages = new Set();
        actives.forEach( a => {
            if ( a.stage && a.stage.length ) {
                stages.add( a.stage );
            }
        } );
        // console.log( stages );
        // setStages( [...stages] );

        const c = gridFilterableColumnLookupSelector( gridRef );
        if ( c && c.stage ) {
            c.stage.valueOptions = [ ...Array.from( stages ) ];
        }
        
        const visibleRows = gridFilteredSortedRowIdsSelector( gridRef );
        const rows = actives.filter( d => visibleRows.includes( d.id ) );
        setTrx( rows.length );

        let v = 0;
        let rev = 0;
        rows.forEach( r => {
            if ( r.amount ) {
                let amt = r.amount;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                v += amt;
            }
            if ( r.revenue ) {
                let amt = r.revenue;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                rev += amt;
            }
        } );
        setVol( v );
        setRev( rev );
    }, [ actives, gridRef ] );

    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const allLids = [];
        const emailLids = [];
        const phoneLids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( lid => {
            const l = loans[lid];
            if ( l.borrowers?.length ) {
                let seenEmails = false;
                let seenPhones = false;
        
                allLids.push( lid );
                        
                for ( const b of l.borrowers ) {
                    const c = contacts[b.cid];
                    if ( c ) {
                        if ( c?.email && ( uniqueEmails.has( c.email.toLowerCase() ) || c.optoutEmail ) ) {
                            seenEmails = true;
                        }
                        let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                        if ( p && ( uniquePhones.has( formatPhone( p  ) ) || c.optoutSms ) ) {
                            seenPhones = true;
                        }
                    }
                }
        
                if ( !seenEmails ) {
                    emailLids.push( lid );
                }
                if ( !seenPhones ) {
                    phoneLids.push( lid );
                }
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} llist={emailLids} objType='loan' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} llist={phoneLids} objType='loan' /> );
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='loans' items={allLids} aid={viewing[0]} /> );
                break;
    
            // case 'event':
            //     setModal( <AddEvent close={closeModal} contacts={contacts} /> );
            //     break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='loans' data={allLids} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        document.title = 'Third Floor - Construction Loans';
    }, [] );
    
    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.constructionloans && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );

            let storedCols = JSON.parse( grids.constructionloans.cols );
            if ( filters.fn && grids.constructionloans.filters && grids.constructionloans.filters[filters.fn] ) {
                if ( grids.constructionloans.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.constructionloans.filters[filters.fn].cols );
                }

                if ( grids.constructionloans.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.constructionloans.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.constructionloans.filters[filters.fn].className ) {
                    setClassLogic( grids.constructionloans.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.constructionloans.className ) {
                    setClassLogic( grids.constructionloans.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }
                    
                    if ( user && user.datagrids && user.datagrids.constructionloans ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.constructionloans.filters && user.datagrids.constructionloans.filters[filters.fn] && user.datagrids.constructionloans.filters[filters.fn].colSize && user.datagrids.constructionloans.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.constructionloans.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.constructionloans.colSize && user.datagrids.constructionloans.colSize[c.field] ) {
                            c.width = user.datagrids.constructionloans.colSize[c.field];
                        }
                    }
                    // c.editable = true;
                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.constructionloans ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.constructionloans.filters && user.datagrids.constructionloans.filters[filters.fn] && user.datagrids.constructionloans.filters[filters.fn].colOrder && user.datagrids.constructionloans.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.constructionloans.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.constructionloans.colOrder && user.datagrids.constructionloans.colOrder.length ) {
                            cols = user.datagrids.constructionloans.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, query, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - numbersRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( loans ) {
            const stats = status.filter( s => s.queue === 'construction' ).map( m => m.value );
            let list = [];
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( stats.includes( l.status ) && viewing.includes( l.aid ) ) {
                    list.push( l );
                }
            } );
            list.sort( ( a, b ) => {
                let ad;
                let bd;

                if ( a.coeDate ) {
                    ad = new Date( a.coeDate );
                } else if ( a.fundingDate ) {
                    ad = new Date( a.fundingDate );
                } else if ( a.recordingDate ) {
                    ad = new Date( a.recordingDate );
                }

                if ( b.coeDate ) {
                    bd = new Date( b.coeDate );
                } else if ( b.fundingDate ) {
                    bd = new Date( b.fundingDate );
                } else if ( b.recordingDate ) {
                    bd = new Date( b.recordingDate );
                }

                if ( !ad && !bd ) {
                    return 0;
                }
                if ( !ad ) {
                    return 1;
                }
                if ( !bd ) {
                    return -1;
                }
                return ad.getTime() - bd.getTime();
            } );

            setActives( list );
            setLoading( false );
        }
    }, [ loans, status, viewing ] );

    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Construction Loans</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Subtitle className='py-3' ref={numbersRef}>
                              <Row className='text-center'>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>{trx}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Loans</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( vol, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Volume</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-value'>${formatShorthand( rev, 2 )}</Col>
                                    </Row>
                                    <Row>
                                        <Col className='tf-dashboard-section-highlight-label'>Revenue</Col>
                                    </Row>
                                </Col>
                              </Row>
                            </Card.Subtitle>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ActiveLoansModal.Provider value={ { openModal, closeModal, setModal } }>
                                        {
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                    } }
                                                    loading={ loading }
                                                    rows={actives}
                                                    columns={cols}
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                    getRowClassName={ getRowClassName }
                                                    editMode='row'
                                                    onStateChange={updateKPIs}
                                                    getRowId={ ( row ) => row.lid }
                                                />
                                            ) : (
                                                <Spinner />
                                            )
                                        }
                                    </ActiveLoansModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    status: state.user.meta.loan.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( LoansConstruction );